import processFilterOptions from './processFilterOptions';
import expandFilterOptions from './expandFilterOptions';
const getFilterOptions = (options) => processFilterOptions(expandFilterOptions(options));
export default getFilterOptions;
